import React from 'react'
import './hero.css'


const Hero = () => {
  return (
      <section >

              <div className=' container px-[20px] md:pl-[61px] md:pr-[57px] text-white'>
                   <p className='h-[120px] md:h-[176px]  md:w-[607px] text-[24px] md:text-[36px] leading-[30px] md:leading-[44px] font-medium pt-[141px] md:pt-[170px]'>
                       Need Money ? Call Now All loans available,Home loan,Personal loans,Machinery 
                       loans etc
                    </p>
                    <p className='text-hero md:w-[607px] text-[16px] leading-[20px] tracking-[0.005em] font-normal mt-[150px] md:mt-[150px]'>Kpoikpoimingi limited is a Nigerian organization built on trust tailored to help  meet your financial goals because trust is a great determinant for business scuccess</p>
                    <a href="#contact" className='btn'>Contact Us</a>
                </div>
      </section>

  )
}

export default Hero